import {createReducer} from "../../common/utils/reducerUtils";

import {TAB_SELECTED2, TAB_NEW2} from "./tabsConstants2";

const initialState2 = {
    currentTab2 : "initHome",
};

export function selectTab2(state, payload) {
    return {
        currentTab2 : payload.tabName,
    };
}

export function newTab2(state, payload) {
    return {
        currentTab2 : payload.tabName,
    };
}

export default createReducer(initialState2, {
    [TAB_SELECTED2] : selectTab2, [TAB_NEW2] : newTab2,
});
